import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MainService } from "src/app/services/main-service.service";
import { ProposalService } from "src/app/services/proposal/proposal.service";
import { Subject } from "rxjs";
import { ProvidersService } from "src/app/services/providers.service";
import { ModalDirective } from "ngx-bootstrap/modal";
// import { plaidService } from "src/app/services/plaid.service";
import { ActivatedRoute } from "@angular/router";
import { ToasterService } from "src/app/services/toaster.service";

@Component({
  selector: "app-modal-base",
  templateUrl: "./modal-base.component.html",
  styleUrls: ["./modal-base.component.scss"],
})
export class ModalBaseComponent implements OnInit {
  payment_from = null;
  bank_intent;
  card_intent;
  payment_method_type: any;
  cvc_update: any;
  buttonClickedSubject: Subject<any> = new Subject();
  add_bank_step: string;
  bank_search = "";
  supported_banks = [];
  error_message = "";
  buttonSelectedType = {
    existing: 1,
    bank: 2,
    cardTab: 3,
  };
  params = {
    provider_id: "",
    product_code: "",
    auth_token: "",
  };
  @ViewChild("verifyModal") verifyModal: ModalDirective;
  todayPaymentCard: boolean = false;
  selected_option: any;
  selectedBank: any;
  selected_card: any;
  selectedCard: any;
  showAddBankBtn: boolean = false;
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<ModalBaseComponent>,
    public _mainService: MainService,
    public _proposal: ProposalService,
    public _provider: ProvidersService,
    public toasterService: ToasterService,
    // public _plaid: plaidService,
    public _routes: ActivatedRoute
  ) {}

  ngOnInit() {
    this.params.product_code = this._routes.snapshot.queryParams.product_code;
    this.params.provider_id =
      this._routes.snapshot.queryParams.provider_id || "";
    this.params.auth_token = this._routes.snapshot.queryParams.auth_token;
    if (
      this.data &&
      this.data.send_data &&
      this.data.send_data["payment"] &&
      this.data.send_data["payment"].length
    ) {
      this.selectedBank = this.data.send_data["payment"].filter(
        (item) => item.payment_source_type === 1
      );
      this.selectedCard = this.data.send_data["payment"].filter(
        (item) => item.payment_source_type !== 1
      );
      if (this.selectedBank && this.selectedBank.length > 0) {
        this.getSelectedCard(this.selectedBank[0]);
      }
    }

    // for perticular business we changed the flow (themeChanges)
    if (this.data && this.data.send_data && !this.data.send_data.themeChanges) {
      this.existing(this.data && this.data.send_data && this.data.send_data.bank_enable && this.data.send_data.bank_enable.currency && this.data.send_data.bank_enable.currency[0] && this.data.send_data.bank_enable.currency[0].bank_support_type ? this.buttonSelectedType.bank : this.buttonSelectedType.cardTab);
    } else {
      this.existing(this.buttonSelectedType.cardTab);
    }
    console.log(this.data);
  }
  getSelectedCard(es) {
    this.selected_card = es;
    console.log(this.selected_card);
  }

  existing(data) {
    if (data === this.buttonSelectedType.cardTab) {
      this.showAddBankBtn = false;
      this.add_bank_step = "card";
      this.payment_from = null;
      if (!this.selectedCard || (this.selectedCard && !this.selectedCard.length)) {
        this.selected_option = 2;
        setTimeout(() => {
          this.removeCvcElement("iframe_cvc_card");
          this.AddStripeElement("iframe_add_card");
        }, 200);
        this.payment_from = 2;
        this.createPaymentIntent();
      } else {
        this.selected_option = 1;
        this.payment_from = 3;
      }
    } else if (data === this.buttonSelectedType.bank) {
      if (!this.selectedBank || (this.selectedBank && !this.selectedBank.length)) {
        this.add_bank_step = 'bank';
        this.selected_option = null;
        this.payment_from = 1;
        if (this.data && this.data.send_data && this.data.send_data.country_code.toUpperCase() == 'CA') {
          this.showAddBankBtn = true;
        } else {
          setTimeout(() => {
            this.createPaymentIntent();
          }, 200);
        }
      } else {
        this.add_bank_step = 'bank';
        // this.selected_option = null;
        this.payment_from = 1;
      }
      }
  }

  confirmPayment() {
    if (this.payment_from === 1 && !this.selected_card) {
      this._mainService.customPopups('Please select the bank' , 1);
      return;
    }
    this._mainService.setLoader(true);
    if (this.payment_from === 1) {
      const obj = {
        token: {
          card: this.selected_card,
          id: this.selected_card['source_id'],
          payment_source_type: this.payment_from, // for bank
        },
      };
      if (this.add_bank_step === 'bank') {
        obj['bank_status'] = 'succeeded';
        this.StripeTokenCreated(obj);
      }
    } else {
      if (
        this.payment_from === 2 ||
        this.payment_from === 3
      ) {
        if (this.payment_from === 3) {
                      this.GetStripeToken('iframe_cvc_card');
                  } else {
          // this.GetStripeToken('iframe_add_card');
          this._mainService.setLoader(true);
          this._mainService.stripe
            .confirmSetup({
              elements: this._mainService.stripePaymentIntent,
              confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: window.location.href,
              },
              redirect: "if_required",
            })
            .then((resp) => {
              if (resp.setupIntent && resp.setupIntent.payment_method) {
                const obj = {
                  id: resp.setupIntent.id,
                  payment_source_type: this.payment_from, // for bank
                };
                this.StripeTokenCreated(obj);
              } else {
                console.log(resp);
                this._mainService.setLoader(false);
              }
            })
            .catch((err) => {
              this._mainService.setLoader(false);
            });
        }
      }
    }
  }

  selected(value) {
    this.selected_option = value;
    const cardSelect = value;
    console.log(cardSelect);
    if (cardSelect === 1) {
      this.payment_from = 3;
        this.RemoveStripeElement("iframe_add_card");
        this.AddCardCvcElement("iframe_cvc_card");
    }
    if (cardSelect === 2) {
        this.removeCvcElement("iframe_cvc_card");
        this.AddStripeElement("iframe_add_card");
      this.payment_from = 2;
      this.createPaymentIntent();
    }
  }

  AddStripeElement(element_id) {
    // setTimeout(() => {
    // this._mainService.stripe_element.mount('#' + element_id);
    // }, 1000);
  }
  AddCardCvcElement(element_id) {
    setTimeout(() => {
      this._mainService.cardCvcElement.mount("#" + element_id);
    }, 1000);
  }
  RemoveStripeElement(element_id) {
    this._mainService.stripe_element.unmount("#" + element_id);
  }

  removeCvcElement(element_id) {
    this._mainService.cardCvcElement.unmount("#" + element_id);
  }

  GetStripeToken(button_action) {
    setTimeout(() => {
      this.buttonClickedSubject.next(button_action);
    }, 1000);
  }

  // createPaymentIntent() {
  //   if (!this.payment_from) {
  //     return;
  //   }
  //   this._mainService.setLoader(true);
  //   // if (this.payment_from === 2 && this.card_intent) {
  //   //   this.openStripepaymentMethod(this.card_intent);
  //   //   return;
  //   // } else if (this.payment_from === 1 && this.bank_intent) {
  //   //   this.openStripepaymentMethod(this.bank_intent);
  //   //   return;
  //   // }
  //   const params = {
  //     payment_source_type: this.payment_from,
  //     pc_code: this.data.send_data["parmas"].product_code,
  //     patient_email: this.data.send_data["customer_details"].patient_email,
  //   };
  //   this._proposal
  //     .api(
  //       "post",
  //       "create_payment_intent_finance",
  //       this._mainService.urlParams(params)
  //     )
  //     .subscribe((response) => {
  //       this._mainService.setLoader(false);
  //       this._mainService.patient_id = response.patient_id;
  //       if (response.is_error === 0 && response.client_secret) {
  //         this.payment_method_type = response.payment_method_type;
  //         if (this.payment_from === 2) {
  //           this.card_intent = response.client_secret;
  //         } else {
  //           this.bank_intent = response.client_secret;
  //         }
  //         this.openStripepaymentMethod(response.client_secret);
  //         // if (response.payment_method_type && response.payment_method_type.length && response.payment_method_type.includes('acss_debit')) {
  //         // } else {
  //         //   this._mainService.setLoader(false);
  //         //   this._mainService.createStripeElmentsDynamic(response.client_secret);
  //         //   if (this._mainService.stripeElement2PaymentIntent) {
  //         //     this._mainService.stripeElement2PaymentIntent.mount('#payment-element');
  //         //   }
  //         // }
  //       } else {
  //         this._mainService.customPopups(
  //           "Something went wrong, please try again later",
  //           1
  //         );
  //       }
  //     });
  // }
  private isCreatingIntent = false;
  createPaymentIntent() {
    if (this.isCreatingIntent) {
      return; // prevents second call
    }

    // try {
    if (!this.payment_from) {
      return;
    }

    this.isCreatingIntent = true;
    this._mainService.setLoader(true);

    const params = {
      payment_source_type: this.payment_from,
      pc_code: this.data.send_data["parmas"].product_code,
      patient_email: this.data.send_data["customer_details"].patient_email,
    };

    this._proposal
      .api("post", "create_payment_intent_finance", this._mainService.urlParams(params))
      .subscribe({
        next: (response) => {
          this.isCreatingIntent = false;
          this._mainService.setLoader(false);

          if (response.is_error === 0 && response.client_secret) {
            this._mainService.patient_id = response.patient_id;
            this.payment_method_type = response.payment_method_type;

            if (this.payment_from === 2) {
              this.card_intent = response.client_secret;
            } else {
              this.bank_intent = response.client_secret;
            }

            this.openStripepaymentMethod(response.client_secret);
          } else {
            this._mainService.customPopups("Something went wrong", 1);
          }
        },

        error: (err) => {
          this.isCreatingIntent = false;
          this._mainService.setLoader(false);
          this.dialogRef.close();
          this._mainService.customPopups("Unable to create payment intent", 1);
        }
      });

    // } catch (error) {
    //   this.isCreatingIntent = false; 
    //   this._mainService.setLoader(false);
    //   this.dialogRef.close();
    //   this._mainService.customPopups("Unexpected system error", 1);
    // }
  }


  StripeTokenCreated(data) {
    console.log(data);
    this._mainService.setLoader(false);
    data["payment_from"] = this.payment_from;
    console.log(data);
    this._mainService.stripeTokenData.next(data);
    if (data) {
      this.dialogRef.close();
    }
  }
  openStripepaymentMethod(client_secret) {
    this._mainService.setLoader(false);
    if (
      this.payment_from === 1 &&
      this.bank_intent &&
      this.payment_method_type &&
      this.payment_method_type.length &&
      this.payment_method_type.includes("acss_debit")
    ) {
      this._mainService.setLoader(true);
      this._mainService.stripe
        .confirmAcssDebitSetup(client_secret, {
          payment_method: {
            billing_details: {
              name:
                this.data.send_data["customer_details"].patient_first_name +
                this.data.send_data["customer_details"].patient_last_name,
              email: this.data.send_data["customer_details"].patient_email,
            },
          },
        })
        .then((resp) => {
          this._mainService.setLoader(false);
          if (resp && resp.setupIntent && resp.setupIntent.id) {
            const params = {
              payment_method_id: resp['setupIntent']['payment_method']
            };
            this._proposal.api('post', 'get_paymentmethod_intent', this._mainService.urlParams(params)).subscribe((paymentMethod) => {
              if (paymentMethod.is_error) {
                this._mainService.setLoader(false);
                this.toasterService.message(paymentMethod.error.message,2);
              } else {
                const final_token = {
                  id: resp.setupIntent.id,
                  card: paymentMethod.info.new_model_paymentMethod['acss_debit'],
                  extra_data: {}
                };
                this._mainService.createContractData.next({ token: final_token, save_card: 0 });
                this.StripeTokenCreated({ token: final_token, save_card: 0 });
              }
            });
          }
        });
    } else {
      const data = {
        patient_name:
          this.data.send_data["customer_details"].patient_first_name +
          this.data.send_data["customer_details"].patient_last_name,
        email: this.data.send_data["customer_details"].patient_email,
        patient_address: this.data.send_data["customer_details"].address,
        patient_city: this.data.send_data["customer_details"]["city"],
        patient_state: this.data.send_data["customer_details"]["state_code"] || this.data.send_data["customer_details"]["state_name"],
        patient_zip: this.data.send_data["customer_details"].zip,
        country_code: this.data.send_data["country_code"],
      };
      this._mainService.createStripeElmentsDynamic(client_secret, 0, data);
      if (this._mainService.stripeElement2PaymentIntent) {
        this._mainService.stripeElement2PaymentIntent.mount("#payment-element");
      }
      if (this.payment_from != 1) {
        if (this._mainService.stripeAddressElement) {
          this._mainService.stripeAddressElement.mount("#address-element");
        }
      }
    }
  }

  // checkCustomerBank(get_last4) {
  //   const params = {
  //     customer_first_name:
  //       this.data.send_data["customer_details"].patient_first_name,
  //     customer_last_name:
  //       this.data.send_data["customer_details"].patient_last_name,
  //     customer_mobile: this.data.send_data["customer_details"].patient_mobile,
  //     customer_email: this.data.send_data["customer_details"].patient_email,
  //     get_last4: get_last4,
  //     customer_mobile_country_code:
  //       this.data.send_data["customer_details"].patient_mobile_country_code,
  //   };
  //   this._mainService.setLoader(true);
  //   let provider_id = '';
  //   if (this.data.send_data["params"] && this.data.send_data["params"].provider_id) {
  //     provider_id = this.data.send_data["params"].provider_id;
  //   }
  //   this._provider
  //     .api(
  //       "post",
  //       `v1/staraligners/customer/check?provider_id=${provider_id}&product_code=${this.data.send_data["params"].product_code}&auth_token=${this.data.send_data["params"].auth_token}`,
  //       this._mainService.urlParams(params)
  //     )
  //     .subscribe(
  //       (data: any) => {
  //         this._mainService.setLoader(false);
  //         if (data) {
  //           this._mainService.setLoader(false);
  //           if (data && typeof data === "string") {
  //             data = JSON.parse(data);
  //           }
  //           if (
  //             data.data.customer_details &&
  //             data.data.customer_details.customer_id
  //           ) {
  //             this.data.send_data["customer_details"].patient_id =
  //               data.data.customer_details.patient_id;
  //             this.data.send_data["customer_details"].customer_id =
  //               data.data.customer_details.customer_id;
  //             if (
  //               this.data.send_data["customer_details"].bank_added &&
  //               this.data.send_data["payment_from"] === 1
  //             ) {
  //               this.data.send_data["customer_details"].bank_status =
  //                 data.data.customer_details.bank_status;
  //               this.data.send_data["customer_details"].bank_added =
  //                 data.data.customer_details.bank_added;
  //               this.data.send_data["customer_details"].bank_name =
  //                 data.data.customer_details.bank_name;
  //               this.data.send_data["customer_details"].bank_source_id =
  //                 data.data.customer_details.bank_source_id;
  //               if (get_last4) {
  //                 this.data.send_data["customer_details"].bank_last4 =
  //                   data.data.customer_details.bank_last4;
  //               } else {
  //                 this.verifyModal.show();
  //               }
  //             } else {
  //               const actual_cache_data = {
  //                 customer_details: this.data.send_data["customer_details"],
  //                 businessInfo: this.data.send_data["businessInfo"],
  //                 selected_plan: this.data.send_data["selected_plan"],
  //                 selected_plan_index:
  //                   this.data.send_data["selected_plan_index"],
  //                 finance_plans: this.data.send_data["finance_plans"],
  //                 service_cost_selected:
  //                   this.data.send_data["service_cost_selected"],
  //                 down_payment_selected:
  //                   this.data.send_data["down_payment_selected"],
  //                 time_period_selected:
  //                   this.data.send_data["time_period_selected"],
  //                 selected_product_service:
  //                   this.data.send_data["selected_product_service"],
  //               };
  //               localStorage.setItem(
  //                 "actual_cache_data",
  //                 JSON.stringify(actual_cache_data)
  //               );
  //               this.createPaymentIntent();
  //               // this._plaid.openPlaidPopup({
  //               //   type: 7,
  //               //   patient_id: this.customer_details.patient_id,
  //               //   provider_id: this.params.provider_id,
  //               //   product_code: this.params.product_code,
  //               //   auth_token: this.params.auth_token
  //               // });
  //             }
  //           } else {
  //             console.log("case fass gaya");
  //           }
  //         }
  //       },
  //       (error: any) => {
  //         this._mainService.setLoader(false);
  //         console.log(error);
  //         if (error.error.message) {
  //           this._mainService.customPopups(error.error.message, 1);
  //         }
  //         this._mainService.setLoader(false);
  //       }
  //     );
  // }

  searchBankData(bank_search) {
    if (!bank_search) {
      this._mainService.customPopups("Please enter a valid bank name", 1);
      return;
    }
    this._mainService.setLoader(true);
    const api_data = {
      search: bank_search || "a",
    };
    this._proposal
      .api(
        "post",
        "get_plaid_institutes",
        this._mainService.urlParams(api_data)
      )
      .subscribe(
        (data: any) => {
          this._mainService.setLoader(false);
          if (data.is_error) {
            if (data.override_text) {
              this._mainService.customPopups(data.override_text, 1);
            } else {
              this._mainService.customPopups(data.err || data.error, 1);
            }
          } else {
            this.supported_banks = data.institutions;
          }
        },
        (err: any) => {
          this._mainService.setLoader(false);
        }
      );
  }

  resetBanks() {
    this.bank_search = "";
    this.supported_banks = [
      { name: "Chase" },
      { name: "Bank of America" },
      { name: "Wells Fargo" },
      { name: "Citi" },
      { name: "U.S. Bank" },
      { name: "SunTrust - Online Banking" },
      { name: "Capital One" },
      { name: "Goldman Sachs Private Wealth Management" },
    ];
  }
}

export interface DialogData {
  title?: string;
  desc?: string;
  action?: string;
  actionClass?: string;
  type?: any;
  paymentInfo: boolean;
  send_data?: any;
  popup_data?: { tips_text?: {} };
  email?: any;
  added?: any;
  allContracts?: any;
  downloadPdf?: any;
  noFeePaymentCards?: any;
  customNoFeeAvailableMonth?: any;
  filteredArray?: any;
  paymentType?: any;
  downpaymentCost?: any;
  interestRateAmt?: any;
  doctor_id?: any;
  totalServAmt?: any;
  estimatedServiceCost?: any;
  country_code?: any;
}
